import React, { FunctionComponent, useEffect, useState } from 'react'
import { GenericComboDTO, Address, initialStateAddress, AddressCardProps, AddressCard } from 'medere-ui-framework';
import { useLocationService } from '../../servicesHooks/Location/useLocationService';
import { ComboDataDTO } from '../../dto/ComboDataDTO';
// @ts-ignore
import AddressForm from './AddressForm/AddressForm';


type InputAddressProps<AdditionalProps = {}> = {
  addresses: Address[],
  setAddresses: (addresses: Address[]) => void,
  disabled?: boolean
  getAllAddressTypes: () => Promise<GenericComboDTO[]>
  addressCard?: FunctionComponent<AddressCardProps & AdditionalProps>
  addressAdditionalCardProps?: AdditionalProps
}

export default function InputAddress<AdditionalProps = {}>({ addresses, setAddresses, disabled = false, getAllAddressTypes, addressCard = AddressCard, addressAdditionalCardProps = {} as AdditionalProps}: Readonly<InputAddressProps<AdditionalProps>>) {
  const { getDefaultCity } = useLocationService();
  const [newAddressTypes, setNewAddressTypes] = useState<GenericComboDTO[]>([]);
  const [newAddress, setNewAddress] = useState<Address>(initialStateAddress)
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [selectedCity, setSelectedCity] = useState<ComboDataDTO | null>(null);

  useEffect(() => {
    getAllAddressTypes().then((res: GenericComboDTO[]) => {
      setNewAddressTypes(res)
    });

    getDefaultCity().then((res: ComboDataDTO)=>{
      setSelectedCity(res)
    })
  }, [])

  function isValid(address: any) {
    return address.addressdesc !== "" && address.types.length > 0 && address.city !== -1;
  }

  function deleteAddressHandler(i: number) {
    let _adresses = [...addresses];
    _adresses.splice(i, 1);
    setAddresses(_adresses);
  }

  function editAddressHandler(address: Address, i: number) {
    deleteAddressHandler(i);
    setSelectedCity({ id: address.city, name: address.citydesc, isExternalId: (address as any).cityExternalId ?? false })
    setNewAddress(address);
    setPreviousEditAddress(address)
    setIsEditing(true);
  }

  function cancelHandler() {
    setIsEditing(false)
    setNewAddress(initialStateAddress);
    setSelectedCity(null)
  }

  function onAddAddress(addressToAdd?: Address) {
    const resolvedAddress = addressToAdd ?? newAddress;

    if (isValid(resolvedAddress)) {
      if (addresses !== null) {
        setAddresses([...addresses, { ...resolvedAddress, hasChanges: true }]);
      } else {
        setAddresses([{ ...resolvedAddress, hasChanges: true }]);
      }
      cancelHandler();
    }
  }

  const [previousEditAddress, setPreviousEditAddress] = useState<Address>(initialStateAddress)

  function cancelChanges() {
    setAddresses([...addresses, { ...previousEditAddress }]);
    cancelHandler();
  }

  return (
    <div className='flex flex-column'>
      {!disabled &&
        <AddressForm
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
          isEditing={isEditing}
          newAddress={newAddress}
          setNewAddress={setNewAddress}
          newAddressTypes={newAddressTypes}
          onAddAddress={onAddAddress}
          cancelChanges={cancelChanges} />}
      {addresses && addresses.length > 0 && <div className='flex flex-column mt-2'>
        {addresses.map((address: Address, index: number) => {
          return React.createElement(addressCard, {
            disabled,
            key: "address" + index,
            index,
            address,
            onDelete: deleteAddressHandler,
            onEdit: editAddressHandler,
            ...addressAdditionalCardProps,
          }) 
        })}
      </div>}
    </div>
  )
}
